import React, { useEffect, useState} from "react";
import {Button} from 'react-bootstrap';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { IconButton } from "@mui/material";

const SensorButton = props => {
    const toggleModalState = () => {

    }

    return (
        <>
        {
            props.method === 'add' &&
            <Button onClick={() => props.clickAction()} variant='outline-dark' style={{marginBottom:'2%'}}>
                <strong>{props.label}</strong>
            </Button>
        }
        {
            ['edit', 'delete'].includes(props.method) && 
            <IconButton onClick={() => props.clickAction()}>
                {props.method === 'edit' ? <EditTwoToneIcon/> : <DeleteTwoToneIcon style={{fill: "red"}}/>}
            </IconButton>
        }
        
        </>
    )
}

export default SensorButton;